import { Check } from "@mui/icons-material";
import Alert from "@mui/material/Alert";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import project_types from "../../data/projects/enums/teammate_project_experience";
import { url } from "../../url";
import styles from "./styles/alert.module.scss";

export default function ProjectType({
  pickedOptions,
  setPickedOptions,
  show,
  setShow,
  displayColumn,
  title = "Project Type Experience",
  isAdd,
}: {
  pickedOptions: string[];
  setPickedOptions: (newState: any) => void;
  show: boolean;
  setShow: (key: string) => void;
  displayColumn?: boolean;
  title?: string;
  isAdd?: boolean;
}) {
  // const [show, setShow] = useState<boolean>(false);
  const location = useLocation();
  const [originalOptions, setOriginalOptions] =
    useState<string[]>(project_types);
  const [allOptions, setAllOptions] = useState<string[]>(originalOptions);
  // const [pickedOptions, setPickedOptions] = useState<string[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [adding, setAdding] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (searchText === "") {
      const unpickedOptions = originalOptions.filter(
        (option) => !pickedOptions.includes(option)
      );
      setAllOptions(unpickedOptions);
      if (location.pathname === "/teammates/add") {
        setAdding(false);
      }
    } else {
      const filteredOptions = originalOptions.filter(
        (option) =>
          !pickedOptions.includes(option) &&
          option.toLowerCase().includes(searchText.toLowerCase())
      );
      setAllOptions(filteredOptions);
      if (
        location.pathname === "/teammates/add" &&
        filteredOptions.length === 0 &&
        adding === false
      ) {
        setAdding(true);
      } else if (
        location.pathname === "/teammates/add" &&
        filteredOptions.length > 0 &&
        adding === true
      ) {
        setAdding(false);
      }
    }
  }, [searchText, pickedOptions, originalOptions]);
  const handleClick = (index: number) => {
    const selectedOption = allOptions[index];
    const updatedOptions = allOptions.filter((_, i) => i !== index);
    setAllOptions(updatedOptions);
    if (!pickedOptions.includes(selectedOption)) {
      setPickedOptions([...pickedOptions, selectedOption]);
    }
  };
  const handleRemove = (index: number) => {
    try {
      const removedOption = pickedOptions[index];
      const updatedPickedOptions = pickedOptions.filter((_, i) => i !== index);
      setPickedOptions(updatedPickedOptions);
      if (!allOptions.includes(removedOption)) {
        const updatedOptions = [...allOptions, removedOption].sort((a, b) => {
          const numA = parseInt(a.match(/\d+/)![0]);
          const numB = parseInt(b.match(/\d+/)![0]);
          return numA - numB;
        });
        setAllOptions(updatedOptions);
      }
    } catch (err) {
      // do literally nothing
    }
  };

  const onClickProposeButton = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        url + "/proposition",
        {
          proposition: searchText,
          filterType: "projectType",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAdding(false);
      setSearchText("");
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3500);
    } catch (err) {
      // handler error
      console.log(err);
    }
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchText = e.target.value;
    setSearchText(searchText);
  };
  return (
    <>
      <div className="component set_border_2_grey">
        <div onClick={() => setShow("projectType")} className="title">
          <p>
            {title}&nbsp;
            {pickedOptions.length > 0 && (
              <span className="ml_3">({pickedOptions.length})</span>
            )}
          </p>
          <i
            className={`${
              show && "rotate"
            } fa-solid fa-chevron-down cursor-pointer`}
          />
        </div>
        {show && (
          <div
            className="show_component"
            style={
              isAdd
                ? { left: 0, right: 0, borderLeft: 0, borderRight: 0 }
                : undefined
            }
          >
            <div className="mainContentBox" style={{ flexDirection: "column" }}>
              {/* search section */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  gap: "8px",
                  marginBottom: "8px",
                  alignItems: "center",
                }}
              >
                <input
                  type="text"
                  className="search_input"
                  onChange={handleSearch}
                  value={searchText}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && searchText.length) {
                      handleClick(0);
                      setSearchText("");
                    }
                  }}
                  style={{ flex: 1 }}
                />
                {searchText.length > 0 && allOptions.length === 0 && (
                  <button
                    className="propose-button"
                    onClick={onClickProposeButton}
                  >
                    Propose
                  </button>
                )}
              </div>
              {/* picked section */}
              <div className="picked" style={{ padding: "8px 0" }}>
                <h6>Picked</h6>
                <div className="all_options_scroll">
                  {pickedOptions.map((option, index) => (
                    <div
                      key={index}
                      className="option"
                      onClick={() => handleRemove(index)}
                    >
                      <div className="checkbox">
                        <div className="inner_box"></div>
                      </div>
                      <p>{option}</p>
                    </div>
                  ))}
                </div>
              </div>
              {/* all section */}
              <div className="all" style={{ padding: "8px 0" }}>
                <h6>All</h6>
                <div className="all_options_scroll">
                  {allOptions.map((option, index) => (
                    <div className="" key={index}>
                      <div key={index} className="option">
                        <div className="checkbox">
                          <div
                            className="inner_box"
                            onClick={() => handleClick(index)}
                          ></div>
                        </div>
                        <div
                          style={{ fontSize: "" }}
                          onClick={() => handleClick(index)}
                        >
                          {option}
                        </div>{" "}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {showAlert && (
        <div className={styles["alert-container"]}>
          <Alert icon={<Check fontSize="inherit" />} severity="success">
            <h4>Succesfully propose new filter</h4>
          </Alert>
        </div>
      )}
    </>
  );
}
